import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { searchContracts } from "../../API/ApiContratos";
import { AuthContext } from "../../auth/authContext";
import { toast } from "react-toastify";
import styles from "./BuscadorDeContratosParaEliminacionComponent.module.css";

export const BuscadorDeContratosParaEliminacionComponent = (props) => {
  const { user, dispatch } = React.useContext(AuthContext);
  const [finalData, setFinalData] = React.useState([]);
  const [contratoInactivo, setContratoInactivo] = React.useState(false);

  return (
    <>
      <Autocomplete
        disablePortal
        id="combo-box-demo"
        options={finalData}
        getOptionLabel={(option) =>
          `${option.serie} ${option.noContrato} - ${option.titular} (${option.id})`
        }
        onInputChange={(event, option) => {
          if (option !== "") {
            
            searchContracts(user, event.target.value).then((resultado) => {
              if (resultado.status == 200) {
                setFinalData(resultado.data);
              } else {
                setFinalData([]);
              }
            });
          }
        }}
        onChange={(event, option) => {
          if (option !== null) {
            props.setNumeroContratoEncontrado(option);
          }
          setContratoInactivo(false);
        }}
        sx={{ width: "100%" }}
        renderInput={(params) => (
          <TextField {...params} label="Buscar Número de Contrato" />
        )}
      />

      {contratoInactivo == true ? (
        <>
          <div className={styles.buscadorInabilitados}>
            <div className={styles.buscadorInabilitadosCenter}>
              <h5>
                {" "}
                <strong>
                  {" "}
                  Este Contrato esta inhabilitado, <br /> Confirma la
                  información en Cobranza{" "}
                </strong>{" "}
              </h5>

              <br />
              <br />
              <div
                className="btn btn-success"
                onClick={() => {
                  setContratoInactivo(false);
                }}
              >
                Cerrar
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};
